import DashboardVaccinatoreView from "./DashboardVaccinatoreView";

export default DashboardVaccinatoreView;
